import React, { useEffect, useState } from "react";
// styled components
import { Empty} from "antd";
import { Dropdown} from "semantic-ui-react";
// data select
import { cantidadRegistros } from "../../../../utils/dataSelectOptions";
// icons
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
// api services
import apiDocumentos from "../../../../api/Documentos/api-documentos";
import { ReactComponent as IconFlechareg } from "../../../../assets/flecha_reg.svg";

interface IProps {
  postulacion: PostulacionModel;
}

export const ParticipantesPostulacion: React.FC<IProps> = (props: IProps) => {
  // state
  const [participantes, setParticipantes] = useState<any>([]);
  const [cantidadPáginas, setCantidadPáginas] = useState<number>(10);
  const [totalRegistros, setTotalRegistros] = useState<number>(0);
  const [firmasParticipantes, setFirmasParticipantes] = useState<{ [key: number]: string }>({});
  const [nombreGrupo, setNombreGrupo] = useState<string>("");

  //   functions
  useEffect(() => {
    consultarParticipantes();
  }, [props.postulacion]);

  const getSignatureParticipante = async (firma: string, index: number) => {
    try {
      const nombreArchivo = firma.split('/').pop() || firma;
      const data = await apiDocumentos.consultarArchivo(nombreArchivo);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setFirmasParticipantes(prev => ({
            ...prev,
            [index]: base64String as string
          }));
        }
      }
    } catch (error) {
      console.error('Error al obtener la firma del participante:', error);
    }
  };

  const consultarParticipantes = () => {
    const docConParticipantes = props.postulacion.documentos_administrativos?.find(
      (doc: any) => doc.participantes && Array.isArray(doc.participantes) && doc.participantes.length > 0
    );

    if (docConParticipantes) {
      const listaParticipantes = docConParticipantes.participantes;
      setTotalRegistros(listaParticipantes.length);
      setParticipantes(listaParticipantes);

      if (listaParticipantes[0]?.nombreGrupo) {
        setNombreGrupo(listaParticipantes[0].nombreGrupo);
      }

      listaParticipantes.forEach((participante: any, index: number) => {
        if (participante?.firma && typeof participante.firma === 'string') {
          getSignatureParticipante(participante.firma, index);
        }
      });
    } else {
      setTotalRegistros(0);
      setParticipantes([]);
      setNombreGrupo("");
    }
  };

  const cambiarCantidadPaginas = (e: any, value: any) => {
    return setCantidadPáginas(value);
  };

  return (
    <div>
      <div className="row" style={{ padding: "16px" }}>
        <div className="col-12 col-md-6 pb-2 font-size-14px font-family-Montserrat-SemiBold">
          Lista de participantes
        </div>
        <div className="col-12 col-md-6">
          <div className="row g-2">
            <div className="col-10 col-md-10  col-xl-10 col-xxl-11  d-flex justify-content-end align-content-center">
              <span className="pe-4 col d-flex justify-content-md-end font-size-12px">
                Total : <span className="font-color-F28C02">{totalRegistros}</span>
              </span>
              <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                Registros por página
              </span>
            </div>
            <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
              <Dropdown
                fluid
                className="select-registros-adminconvocatoria no-margin"
                defaultValue={cantidadPáginas}
                options={cantidadRegistros}
                icon={<IconFlechareg />}
                onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12" style={{ padding: "16px" }}>
          {nombreGrupo && (
            <div className="mb-3" style={{ fontSize: '14px', fontWeight: 'bold', color: '#051923' }}>
              Nombre del Grupo: <span className="font-color-F28C02">{nombreGrupo}</span>
            </div>
          )}
          {participantes && participantes.length > 0 ? (
            <div style={{ fontSize: '9px', marginTop: '10px' }}>
              {participantes.map((participante: any, index: number) => {
                let fechaNacimiento: string;
                if (!participante.fechaNacimiento) { fechaNacimiento = "—"; }
                else if (typeof participante.fechaNacimiento === 'string') { fechaNacimiento = participante.fechaNacimiento.split('T')[0]; }
                else if (participante.fechaNacimiento.format) { fechaNacimiento = participante.fechaNacimiento.format('YYYY-MM-DD'); }
                else { fechaNacimiento = String(participante.fechaNacimiento).split('T')[0]; }

                return (
                  <div
                    key={participante.documento || participante.nombresApellidos}
                    style={{
                      border: '1px solid #ddd',
                      padding: '8px',
                      marginBottom: '10px',
                      borderRadius: '4px',
                      backgroundColor: '#fafafa'
                    }}
                  >
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '11px' }}>
                      <div><strong>Nombres:</strong> {participante.nombresApellidos || "—"}</div>
                      <div><strong>Rol:</strong> {participante.rol || "—"}</div>
                      <div><strong>Tipo Doc:</strong> {participante.tipoDocumento || "—"}</div>
                      <div><strong>N° Doc:</strong> {participante.numeroDocumento || "—"}</div>
                      <div><strong>Fecha Nacimiento:</strong> {fechaNacimiento}</div>
                      <div><strong>Edad:</strong> {participante.edadCumplida || "—"}</div>
                      <div><strong>Dirección:</strong> {participante.direccionResidencia || "—"}</div>
                      <div><strong>Ciudad:</strong> {participante.ciudad || "—"}</div>
                      <div><strong>Tel. Fijo:</strong> {participante.telefonoFijo || "—"}</div>
                      <div><strong>Tel. Celular:</strong> {participante.telefonoCelular || "—"}</div>
                      <div><strong>Tiempo Residencia:</strong> {participante.tiempoResidencia || "—"} años</div>
                      <div><strong>Correo:</strong> {participante.correoElectronico || "—"}</div>
                    </div>
                    {firmasParticipantes[index] && (
                      <div style={{ marginTop: '8px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                        <div style={{ fontSize: '9px', marginBottom: '4px', fontWeight: 'bold' }}>Firma:</div>
                        <img
                          src={firmasParticipantes[index]}
                          alt={`Firma de ${participante.nombresApellidos || 'participante'}`}
                          style={{
                            maxWidth: '100px',
                            maxHeight: '50px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '2px',
                            backgroundColor: '#fff'
                          }}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} />
          )}
        </div>
      </div>
    </div>
  );
};
